module.exports = __webpack_public_path__ + "static/opengraph-image.9bacab5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/opengraph-image.jpg
// module id = 1321
// module chunks = 114276838955818